import { ConfigCommonHeader } from '@net7/boilerplate-common';

export default {
  logo: {
    // title: 'Petrarca Online',
    // subtitle: 'Base de datos, argumentos y motivos del teatro de Calderón',
    anchor: {
      href: '/',
    },
  },
  nav: {
    items: [],
  },
} as ConfigCommonHeader;
